/* eslint-disable no-underscore-dangle */
import { useTranslation } from 'react-i18next';
import searchStudies from './searchStudies';
import { getIsEditingDates } from '../static/config';
import moment from 'moment';
import { buildQueryFilters } from './studyRequestBuilder';
import { sortStudies } from './studiesResultTools';

export const getStudyList = async (server, filters, userFixedFilters, rowsPerPage, currentPage, sort, PACS_WITHOUT_WILDCARD = false) => {

  if (getIsEditingDates()) return;

  const queryFilters = buildQueryFilters(filters, userFixedFilters, rowsPerPage, currentPage);

  return searchStudies(server, queryFilters, PACS_WITHOUT_WILDCARD).then(studies => {
    // Because we've merged multiple requests, we may have more than
    // our Rows per page. Let's `take` that number from our sorted array.
    // This "might" cause paging issues.
    const sortedStudies = sortStudies(studies, sort);
    const numToTake = sortedStudies.length < rowsPerPage ? sortedStudies.length : rowsPerPage;
    return sortedStudies.slice(0, numToTake);
  });
};




// ~~~ TIME
export const today = moment();
export const threeDaysAgo = moment().subtract(3, 'day');
export const lastWeek = moment().subtract(7, 'day');
export const lastMonth = moment().subtract(1, 'month');
export const lastYear = moment().subtract(1, 'year');
export const any = moment().subtract(50, 'year');

export const studyDatePresets = () => {
  const { t } = useTranslation();

  return [
    {
      text: t('filters.Today'),
      start: today,
      end: today,
    },
    {
      text: t('filters.3DaysAgo'),
      start: threeDaysAgo,
      end: today,
    },
    {
      text: t('filters.AWeekAgo'),
      start: lastWeek,
      end: today,
    },
  ];
};

export const getDateEntry = (datePicked, rangeDatePicked) => rangeDatePicked || datePicked || null;
export const getDateEntryFromRange = (today, numOfDays, edge = 'start') => {
  if (typeof numOfDays !== 'number') {
    return;
  }

  if (edge === 'end') {
    return today;
  }
  today.subtract(numOfDays, 'days');
};

//  ~~~ MODALITIES

export const modalityRackButtons = () => {
  const { t } = useTranslation();

  return [
    {
      text: t('filters.All'),
      modality: '',
    },
    {
      text: t('CT'),
      modality: 'CT',
    },
    {
      text: t('MR'),
      modality: 'MR',
    },
    {
      text: t('MG'),
      modality: 'MG',
    },
    {
      text: t('NM'),
      modality: 'NM',
    },
    {
      text: t('CR'),
      modality: 'CR',
    },
    {
      text: t('US'),
      modality: 'US',
    },
    {
      text: t('XA'),
      modality: 'XA',
    },
    {
      text: t('DX'),
      modality: 'DX',
    },
    {
      text: t('ECG'),
      modality: 'ECG',
    },
  ];
};
